(function () {
    const filters = document.querySelectorAll('.employees-filter');

    for (let i = 0; i < filters.length; i++) {
        filters[i].addEventListener('click', function (event) {
            filterEmployees(event.target.dataset.section);
            switchFilters(filters, event.target);
        });
    }

    function filterEmployees(section) 
    {
        const employees = document.querySelectorAll('.single-employee');

        for (let j = 0; j < employees.length; j++) {
            if (employees[j].classList.contains(section)) {
                employees[j].classList.add('active');
            } else {
                employees[j].classList.remove('active');
            }
        }
    }

    function switchFilters(filters, target)
    {
        for (let k = 0; k < filters.length; k++) {
            filters[k].classList.remove('active');
            target.classList.add('active');
        }   
    }
})();
